/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, Component } from "react";
import Breadcrumb from "../../../component/breadcrumb";
import Button from "../../../component/button";
import classes from "../order/order.module.css";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import { useEffect } from "react";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import actionTypes from "../../../store/actions";
import { connect } from "react-redux";
import UriEncode from "../../../component/uriEncode/uriEncode";
import { withNavigation } from "../../../helper/withNavigation";

// Get adjustment props from parent
class newAdjustments extends Component {
  state = {
    showLoading: true,
    subscriptionId: "",
    name: "",
    category: "",
    type: "",
    invoiceId: "",
    adjValue: "",
    action: "",
    msg: "",
    transactionDetail: "",
    adjustmentId: "",
    notes: "",
    spId: "",
    subscriptionType: "",
    typeList: [],
    subscriptions: [],
    sortBy: "orderId",
    sortOrder: "DESC",
    customerId: "",
    clientId: "",
    bread: [
      {
        title: this.props.t("SUBSCRIPTION_ADJUSTMENTS"),
        url: "/subscriptionadjustments",
      },
    ],
    loading: true,
    partyId: "",
  };
  componentDidMount() {
    this.props.setCompDidMount();

    this.setState({
      loading: true,
      showLoading: true,
    });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ADJUSTMENT_TYPES/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data;
        let all = {
          name: "Adjustment Types",
          value: "Adjustment Types",
        };
        list.unshift(all);
        this.setState({
          typeList: res.data,
          loading: false,
          showLoading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    this.getSubscriptions();
  }

  getSubscriptions = () => {
    this.setState({
      loading: true,
      showLoading: true,
    });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/customers/${UriEncode(this.props.router.location.state.ban)}/client/${this.props.router.location.state.partyId}/subscriptions?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}`,
      {},
    )
      .then((res) => {
        let list = res.data.subscriptions;
        let response = [];
        let all = {
          name: "All Subscriptions",
          value: "All Subscriptions",
        };
        list.unshift(all);
        list.forEach((element) => {
          let data = {};
          data.name = element.productId;
          data.value = element.productName;
          response.push(data);
        });
        this.setState({
          subscriptions: response,
          loading: false,
          showLoading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  createAdjustment = async () => {
    let t = this.props.t;
    this.setState({
      loading: true,
      showLoading: true,
    });

    let data = {
      subscriptionId: this.state.subscriptionId,
      name: this.state.name,
      category: this.state.category,
      type: this.state.type,
      adjValue: {
        amount: this.state.adjValue,
      },
      invoiceId: this.state.invoiceId,
      externalId: "",
      description: this.state.notes,
      partyId: this.props.router.location.state.partyId,
    };
    BusApiCall(
      "POST",
      `${constants.busV44UrlPublic}/subscriptionAdjustments`,
      data,
    )
      .then((res) => {
        this.setState({
          loading: false,
          showLoading: false,
          msg: t("ADJUSTMENT_CREATED_SUCCESFULLY"),
        });
      })
      .catch((e) => {
        console.log(e);
        this.setState({
          loading: false,
          showLoading: false,
          msg: t("DEFAULT_ERROR_MESSAGE"),
        });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // const updateAdjustment = async () => {
  //     setLoading(true);
  //     let data = {
  //         subscriptionId: subscriptionId,
  //         name: name,
  //         category: category,
  //         type: type,
  //         adjValue: {
  //             amount: adjValue
  //         },
  //         accountId: accountId,
  //         externalId: "",
  //         description: notes,
  //         action: action,
  //         externalTransactionDetail: transactionDetail,
  //         spId: spId,
  //         subscriptionType: subscriptionType
  //     }
  //     BusApiCall('PATCH', `${constants.busV44UrlPublic}/subscriptionAdjustments/${props.adjustment.adjustmentId}`, data).then(res => {
  //         setLoading(false)
  //         setMsg(t('ADJUSTMENT_UPDATED_SUCCESFULLY'))
  //     }).catch(e => {
  //         console.log(e)
  //         setLoading(false)
  //         setMsg(t('DEFAULT_ERROR_MESSAGE'))
  //     })
  // }
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              <Grid
                item
                style={{ textAlign: "right" }}
                size={{
                  xs: 6,
                }}
              >
                {
                  /*Pratyush - Check if the user has the new Subscription Adjustment Permission*/
                  <Button>
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {t("NEW_SUBSCRIPTION_ADJUSTMENT")}
                  </Button>
                }
              </Grid>
            </Grid>
          </div>
        </div>
        <div
          style={{
            marginLeft: "100px",
            marginRight: "100px",
            marginTop: "30px",
          }}
        >
          <Grid container spacing={3}>
            <Grid
              item
              size={{
                xs: 8,
              }}
            >
              <Input
                inputClass={classes.inputClass}
                name={"name"}
                placeholder={t("ADJUSTMENT_NAME")}
                value={this.state.name}
                onChange={(e) => {
                  this.onChange(e);
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 4,
              }}
            >
              <Input
                inputClass={classes.inputClass}
                name={"invoiceId"}
                placeholder={t("INVOICE_ID")}
                value={this.state.invoiceId}
                onChange={(e) => {
                  this.onChange(e);
                }}
              />
            </Grid>

            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <div className={classes.searchInputDiv}>
                <Select
                  native
                  size={"small"}
                  variant={"outlined"}
                  name={"type"}
                  inputProps={{
                    name: "type",
                    id: "outlined-native-type",
                  }}
                  //value={(a) => a.value}
                  value={this.state.type}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  selectClass={
                    classes.inputClass +
                    " " +
                    classes.statusSelectBg +
                    " " +
                    classes.searchOrderSelect
                  }
                >
                  {this.state.typeList.map((a) => (
                    <option key={a.value} value={a.value}>
                      {a.value}
                    </option>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <div className={classes.searchInputDiv}>
                <Select
                  native
                  size={"small"}
                  variant={"outlined"}
                  name={"subscriptionId"}
                  inputProps={{
                    name: "subscriptionId",
                    id: "outlined-native-type",
                  }}
                  //value={(a) => a.value}
                  value={this.state.subscriptionId}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  selectClass={
                    classes.inputClass +
                    " " +
                    classes.statusSelectBg +
                    " " +
                    classes.searchOrderSelect
                  }
                >
                  {this.state.subscriptions.map((a) => (
                    <option key={a.value} value={a.value}>
                      {a.value}
                    </option>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                inputClass={classes.inputClass}
                name={"adjValue"}
                placeholder={t("ADJUSTMENT_VALUE")}
                value={this.state.adjValue}
                onChange={(e) => {
                  this.onChange(e);
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {t("NOTES")}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Input
                  inputClass={classes.inputClass}
                  name={"notes"}
                  rows={4}
                  // placeholder={t('NOTES')}
                  value={this.state.notes}
                  multiline={true}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              item
              align={"right"}
              size={{
                xs: 12,
              }}
            >
              <Button
                onClick={() => {
                  this.createAdjustment();
                  this.props.router.navigate("/subscriptionAdjustments");
                }}
              >
                {t("CREATE")}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    menuPaths: state.auth.menuPaths,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(newAdjustments)));
